module.exports = __webpack_public_path__ + "static/media/betson-screenshot-2.cf926caa.png";